import { Mass, Measure } from 'safe-units';

import { shortTons } from './shortTons';

export const barbaraV1Max: Mass = Measure.of(20, shortTons);
export const barbaraV1MaxBuffer: Mass = Measure.of(2.5, shortTons);
